<template>
  <div class="automan-spinner" v-if="loading">
    <svg class="automan-spinner-body" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
      <circle class="automan-spinner-path" fill="none" stroke-width="4" stroke-linecap="round" cx="33" cy="33" r="30" />
    </svg>
  </div>
  <div v-else-if="info && info.status !== 1 && scene === 'render'">
    <img src="https://res.cdn.changbaimg.com/-/9c0ae381463bf424/empty.png" class="cb-img" alt="">
    <p class="text">您访问的页面已暂停访问</p>
  </div>
  <t-node :info="nodeInfo" v-else-if="nodeInfo" :root="true" @node-mounted="nodeMounted" />
  <div v-else-if="error">
    <img src="https://res.cdn.changbaimg.com/-/9c0ae381463bf424/empty.png" class="cb-img" alt="">
    <p class="text">您访问的页面暂无法访问<br>({{ $route.params.pageKey }})</p>
  </div>
</template>

<style lang="stylus" scoped>
  @require '../../assets/style/base.styl';

  // .page.home {
  // }

  .cb-img {
    display: block;
    width: 130px;
    height: 130px;
    display: block;
    margin: 80px auto 30px;
  }
  .text {
    margin: 0;
    font-size: 18px;
    text-align: center;
    color: #CBCBCB;
  }
</style>

<script>
import BasePage from '../../extend/BasePage'
import TNode from '../../components/PerviewNode'
import {fetch} from '../../extend/fetch'
import emptyPage from '../../assets/data/empty.json'
import getGlobalParams from '../../extend/changba-global-params'
import BrowserLogger from 'alife-logger'

export default {
  name: 'Home',
  components: {TNode},
  mixins: [BasePage],
  pageName: '',
  data: function () {
    return {
      loading: true,
      info: null,
      nodeInfo: null,
      scene: '',
      error: false
    }
  },
  watch: {
    '$route' (to, from) {
      // 对路由变化作出响应...
      if (to.path != from.path) {
        // 如果页面改变。load新页面加入
        this.loadPageInfo()
      }
    }
  },
  mounted: function () {
    this.loadPageInfo()
  },
  methods: {
    async loadPageInfo() {
      this.nodeInfo = null

      let data

      // 检查是否有本地数据
      if (window.__AUTOMAN_PAGE_DATA__ !== undefined) {
        this.scene = 'render'
        data = window.__AUTOMAN_PAGE_DATA__
      }
      else {
        data = await this.loadInfoFromServer()

        if (data === false) {
          this.loading = false
          return
        }
      }

      // 增加前端监控
      if (this.scene === 'render') {
        const globalParams = await getGlobalParams();
        const loggerConfig = {
          pid: 'fgw29hkkce@f9bda640d38de2f',
          appType: 'web',
          imgUrl: 'https://arms-retcode.aliyuncs.com/r.png?',
          sendResource: true,
          enableLinkTrace: true,
          behavior: true,
          useFmp: true,
          urlHelper: [
            /\/$/
          ],
          ignore: {
            ignoreErrors: [
              /setShareUrlParams/,
              /__changbaPageHideCallback/,
              /bannerNight/,
              /EasylivePageHideCallback/,
              /EasylivePageShowCallback/,
              /^Script error\.?$/
            ]
          },
          uid: globalParams.userId,
          c1: globalParams.appVersion,
          tag: data.name
        };

        BrowserLogger.singleton(loggerConfig);
      }

      this.info = data
      let info = null
      try {
        info = JSON.parse(this.info.content)
      } catch (error) {
        this.error = true
      }

      // 兼容性处理
      if (info?.type === 'truck/emptyContainer') {
        info.type = emptyPage.type
        info.version = emptyPage.version
        info.path = emptyPage.path

        info.child.forEach(item => {
          if (item.type === 'truck/richtext') {
            item.type = 'main/richtext'
            item.version = '1.0.1'
            item.path = 'https://automan.cdn.changbaimg.com/upload/main/richtext/1.0.1/index.js'
          }
        })
      }

      const canvas = info && info.canvas || {}
      const forDesktop = (/desktop/i).test(canvas.name)

      this.setViewPort(canvas.width, forDesktop)
      this.nodeInfo = info

      // 使用画布的背景色作为 html, body 元素的背景色
      const backgroundColor = info?.style?.['background-color'] ?? ''
      const nodeList = document.querySelectorAll('html, body')

      for (let i = 0; i < nodeList.length; i++) {
        nodeList[i].style.backgroundColor = backgroundColor
      }

      this.setPageTitle(data.name || '唱吧')

      this.loading = false
    },

    async loadInfoFromServer() {
      // automan_default_key 用于废弃的 automan proxy，可以忽略
      const pageKey = this.$route.query.automan_default_key ?? this.$route.params.pageKey
      const historyId = this.$route.query.historyid
      const cert = this.$route.query.cert
      const scene = this.$route.query.preview ? 'preview' : historyId ? 'history_preview' : 'render'
      const params = {
        pageKey
      }
      if (historyId) {
        params.historyid = historyId
      }
      if (!pageKey) {
        console.log('缺少页面ID')
        return false
      }

      if (scene === 'preview' && this.$route.query.automan_iframe_preview === 'yes') {
        document.querySelector('html').classList.add('is-preview')
      }

      this.scene = scene

      let data

      if (scene === 'render') {
        ({ data } = await fetch(`${this.Config.API_PATH}page/detail`, {
          method: 'get',
          data: params
        }))
      } else {
        params.scene = scene
        params.cert = cert;
        ({ data } = await fetch(`${this.Config.API_PATH}editor/pages/detail`, {
          method: 'post',
          json: true,
          data: params
        }))
      }

      return data;
    },

    setViewPort (width = 320, forDesktop = false) {
      width = parseInt(width) || 320
      document.documentElement.classList.add(forDesktop ? 'for-desktop' : 'for-mobile')
      const query = document.querySelector.bind(document)

      if (!navigator.userAgent.match(/mobile|iphone|ipad|android/i) || window.innerWidth >= 768) {
        if (forDesktop) {
          Promise.all([query('#app'), query('#app-wrapper')]).then(([app, wrapper]) => {
            if (app && wrapper) {
              app.style.width = width + 'px'
              query('body').replaceChild(app, wrapper)
            }
          })
        } else {
          // const $appFixed = query('#app-fixed')
          const $appWrapper = query('#app-wrapper')

          if (!$appWrapper) {
            return
          }

          $appWrapper.style.width = width + 'px'
        }
      } else if (!forDesktop) {
        // 设置画布宽度，并缩放视口至画布等大
        const i = window.__clientWidth__ = window.__clientWidth__ || document.documentElement.clientWidth || 320
        const e = i / width
        const o = `width=${width}, initial-scale=${e}, maximum-scale=${e}, minimum-scale=${e}, user-scalable=no, shrink-to-fit=no, viewport-fit=cover`
        document.getElementById('viewport').setAttribute('content', o)
      }
    },
    nodeMounted() {
      this.ema.fire('global:node-mounted');
    }
  }
}
</script>
